<template>
  <div class="reportes-container">
    <div class="card" style="border-radius: 1rem">
      <div class="card-body">
        <h5 class="card-title mb-4">
          <i class="fas fa-chart-bar text-success"></i> Reportes
        </h5>

        <!-- Botón para actualizar reportes -->
        <div class="mb-4">
          <button
            @click="loadReportes"
            class="btn btn-success"
            :disabled="loading"
          >
            <i class="fas fa-sync" :class="{ 'fa-spin': loading }"></i>
            {{ loading ? "Cargando..." : "Actualizar Reportes" }}
          </button>
        </div>

        <!-- Estadísticas -->
        <div class="row mb-4" v-if="!loading && reportData">
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-users text-primary"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadUsuariosDelDia }}
                </h6>
                <p class="stat-label">Usuarios Registrados Hoy</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card" style="cursor: default">
              <div class="stat-icon">
                <i class="fas fa-users text-info"></i>
              </div>
              <div class="stat-content w-100">
                <h6 class="stat-value">
                  {{ reportData.cantidadTotalUsuarios }}
                </h6>
                <p class="stat-label mb-2">Total de Usuarios</p>
                <button
                  type="button"
                  class="btn btn-sm btn-outline-info"
                  @click.stop="downloadUsuariosEmailNotificationsFalse"
                  title="Usuarios con emailNotifications en false"
                >
                  <i class="fas fa-download"></i>
                  Sin notif. email (false)
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-shopping-cart text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadVentasDiaClientes }}
                </h6>
                <p class="stat-label">Ventas App Hoy</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-leaf text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadVentasDiaVitality }}
                </h6>
                <p class="stat-label">Ventas Vitality Hoy</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-hospital text-warning"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadVentasDiaPrestadores }}
                </h6>
                <p class="stat-label">Ventas Prestadores Hoy</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-handshake text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadVentasDelDia }}
                </h6>
                <p class="stat-label">Ventas del Día</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-filter text-info"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadGestionesDelDia }}
                </h6>
                <p class="stat-label">Leads del Día</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-calendar-alt text-primary"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadGestionesMesActual }}
                </h6>
                <p class="stat-label">Leads del Mes</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-list text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadTotalGestion }}
                </h6>
                <p class="stat-label">Total de Leads</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-chart-line text-warning"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadVentasMesActual }}
                </h6>
                <p class="stat-label">Ventas del Mes</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-trophy text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">{{ reportData.cantidadTotalVentas }}</h6>
                <p class="stat-label">Ventas Totales</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadUsuariosConVentas"
              style="cursor: pointer"
            >
              <div class="stat-icon">
                <i class="fas fa-user-check text-success"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadUsuariosConVentas }}
                </h6>
                <p class="stat-label">
                  Usuarios con Ventas
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadUsuariosSinVentas"
              style="cursor: pointer"
              title="Total de usuarios menos quienes tienen al menos un lead como referidor (incluye listado para campañas)"
            >
              <div class="stat-icon">
                <i class="fas fa-user-times text-warning"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadUsuariosSinVentas }}
                </h6>
                <p class="stat-label">
                  Usuarios sin ventas ni referidos
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadUsuariosQueHanReferido"
              style="cursor: pointer"
            >
              <div class="stat-icon">
                <i class="fas fa-user-friends text-primary"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadUsuariosQueHanReferido }}
                </h6>
                <p class="stat-label">
                  Usuarios que han referido
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadUsuariosSoloReferidosNoExitosos"
              style="cursor: pointer"
            >
              <div class="stat-icon">
                <i class="fas fa-user-slash text-warning"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">
                  {{ reportData.cantidadUsuariosSoloReferidosNoExitosos }}
                </h6>
                <p class="stat-label">
                  Solo referidos no exitosos
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadConciliacionRetirosVentas"
              style="cursor: pointer"
            >
              <div class="stat-icon">
                <i class="fas fa-file-invoice-dollar text-primary"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">Pendientes</h6>
                <p class="stat-label">
                  Retiros no pagados - Ventas
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
                <small class="text-muted">
                  Solo solicitudes pendientes de pago con las ventas que las
                  componen
                </small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="stat-card" style="cursor: default">
              <div class="stat-icon">
                <i class="fas fa-calendar-check text-info"></i>
              </div>
              <div class="stat-content w-100">
                <h6 class="stat-value">Por período</h6>
                <p class="stat-label mb-2">Ventas del mes (¿Retirado? Sí/No)</p>
                <!-- <small class="text-muted d-block mb-2">
                  Elige mes actual o mes anterior (mismo criterio que el backend por year/month).
                </small> -->
                <div class="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-info"
                    @click.stop="downloadVentasPorPeriodoMesActual"
                  >
                    <i class="fas fa-download"></i>
                    Mes actual
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-info"
                    @click.stop="downloadVentasPorPeriodoMesAnterior"
                  >
                    <i class="fas fa-download"></i>
                    Mes anterior
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div class="stat-card" style="cursor: default">
              <div class="stat-icon">
                <i class="fas fa-file-invoice text-success"></i>
              </div>
              <div class="stat-content w-100">
                <h6 class="stat-value">Ventas cerradas</h6>
                <p class="stat-label mb-2">
                  Ventas cerradas (¿Pagado? + estado retiro)
                </p>
                <div class="d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-info"
                    @click.stop="downloadVentasCerradasMesActual"
                  >
                    <i class="fas fa-download"></i>
                    Mes actual
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-info"
                    @click.stop="downloadVentasCerradasMesAnterior"
                  >
                    <i class="fas fa-download"></i>
                    Mes anterior
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-success"
                    @click.stop="downloadVentasCerradas"
                  >
                    <i class="fas fa-download"></i>
                    Todo
                  </button>
                </div>
                <small class="text-muted d-block mt-2">
                  Todas las ventas cerradas con información de retiro (si aplica)
                </small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <div
              class="stat-card clickable-card"
              @click="downloadPendientePorRetirar"
              style="cursor: pointer"
            >
              <div class="stat-icon">
                <i class="fas fa-wallet text-warning"></i>
              </div>
              <div class="stat-content">
                <h6 class="stat-value">Pendiente</h6>
                <p class="stat-label">
                  Pendiente por retirar
                  <i class="fas fa-download text-success ml-2"></i>
                </p>
                <small class="text-muted">
                  Usuarios con saldo y las ventas que componen ese saldo
                </small>
              </div>
            </div>
          </div>
        </div>

        <!-- Loading state -->
        <div v-if="loading" class="text-center py-5">
          <i class="fas fa-spinner fa-spin fa-3x text-success"></i>
          <p class="mt-3">Cargando reportes...</p>
        </div>

        <!-- Error state -->
        <div v-if="error" class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle"></i> {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reportes",
  props: {
    tokenAuth: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      reportData: null,
    };
  },
  mounted() {
    this.loadReportes();
  },
  methods: {
    async loadReportes() {
      this.loading = true;
      this.error = null;

      try {
        // Llamar a todos los endpoints en paralelo
        const [
          usuariosHoy,
          totalUsuarios,
          ventasAppHoy,
          ventasVitalityHoy,
          ventasPrestadoresHoy,
          ventasDelDia,
          leadsDelDia,
          leadsDelMes,
          totalLeads,
          ventasDelMes,
          ventasTotales,
          usuariosConVentas,
          usuariosSinVentas,
          usuariosQueHanReferido,
          usuariosSoloReferidosNoExitosos,
        ] = await Promise.all([
          this.$https.get("/adminReports/getUsuariosRegistradosHoy"),
          this.$https.get("/adminReports/getTotalUsuarios"),
          this.$https.get("/adminReports/getVentasAppHoy"),
          this.$https.get("/adminReports/getVentasVitalityHoy"),
          this.$https.get("/adminReports/getVentasPrestadoresHoy"),
          this.$https.get("/adminReports/getVentasDelDia"),
          this.$https.get("/adminReports/getLeadsDelDia"),
          this.$https.get("/adminReports/getLeadsDelMes"),
          this.$https.get("/adminReports/getTotalLeads"),
          this.$https.get("/adminReports/getVentasDelMes"),
          this.$https.get("/adminReports/getVentasTotales"),
          this.$https.get("/adminReports/getUsuariosConVentas"),
          this.$https.get("/adminReports/getUsuariosSinVentas"),
          this.$https.get("/adminReports/getUsuariosQueHanReferido"),
          this.$https.get("/adminReports/getUsuariosSoloReferidosNoExitosos"),
        ]);

        // Combinar todos los datos
        this.reportData = {
          cantidadUsuariosDelDia: usuariosHoy.data.cantidadUsuariosDelDia,
          cantidadTotalUsuarios: totalUsuarios.data.cantidadTotalUsuarios,
          cantidadVentasDiaClientes:
            ventasAppHoy.data.cantidadVentasDiaClientes,
          cantidadVentasDiaVitality:
            ventasVitalityHoy.data.cantidadVentasDiaVitality,
          cantidadVentasDiaPrestadores:
            ventasPrestadoresHoy.data.cantidadVentasDiaPrestadores,
          cantidadVentasDelDia: ventasDelDia.data.cantidadVentasDelDia,
          cantidadGestionesDelDia: leadsDelDia.data.cantidadGestionesDelDia,
          cantidadGestionesMesActual:
            leadsDelMes.data.cantidadGestionesMesActual,
          cantidadTotalGestion: totalLeads.data.cantidadTotalGestion,
          cantidadVentasMesActual: ventasDelMes.data.cantidadVentasMesActual,
          cantidadTotalVentas: ventasTotales.data.cantidadTotalVentas,
          cantidadUsuariosConVentas:
            usuariosConVentas.data.cantidadUsuariosConVentas,
          cantidadUsuariosSinVentas:
            usuariosSinVentas.data.cantidadUsuariosSinVentas,
          cantidadUsuariosQueHanReferido:
            usuariosQueHanReferido.data.cantidadUsuariosQueHanReferido,
          cantidadUsuariosSoloReferidosNoExitosos:
            usuariosSoloReferidosNoExitosos.data
              .cantidadUsuariosSoloReferidosNoExitosos,
        };

        this.$toast.success("Reportes actualizados correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al cargar reportes:", error);
        this.error =
          error.response?.data?.message ||
          "Error al cargar los reportes. Por favor, intente nuevamente.";
        this.$toast.error(this.error, {
          position: "top-right",
          timeout: 5000,
        });
      } finally {
        this.loading = false;
      }
    },
    async downloadUsuariosEmailNotificationsFalse() {
      try {
        this.$toast.info(
          "Generando Excel de usuarios con notificaciones de email desactivadas...",
          {
            position: "top-right",
            timeout: 2000,
          },
        );

        const response = await this.$https.get(
          "/adminReports/downloadUsuariosEmailNotificationsFalseExcel",
          { responseType: "blob" },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `usuarios_email_notifications_false_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar Excel:", error);
        this.$toast.error("Error al descargar el Excel", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadUsuariosConVentas() {
      try {
        this.$toast.info("Generando Excel de usuarios con ventas...", {
          position: "top-right",
          timeout: 2000,
        });

        const response = await this.$https.get(
          "/adminReports/downloadUsuariosConVentasExcel",
          {
            responseType: "blob",
          },
        );

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `usuarios_con_ventas_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar Excel:", error);
        this.$toast.error("Error al descargar el Excel", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadUsuariosSinVentas() {
      try {
        this.$toast.info(
          "Generando Excel de usuarios sin ventas ni referidos...",
          {
            position: "top-right",
            timeout: 2000,
          },
        );

        const response = await this.$https.get(
          "/adminReports/downloadUsuariosSinVentasExcel",
          {
            responseType: "blob",
          },
        );

        // Crear un enlace temporal para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `usuarios_sin_referidos_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar Excel:", error);
        this.$toast.error("Error al descargar el Excel", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadUsuariosQueHanReferido() {
      try {
        this.$toast.info("Generando Excel de usuarios que han referido...", {
          position: "top-right",
          timeout: 2000,
        });

        const response = await this.$https.get(
          "/adminReports/downloadUsuariosQueHanReferidoExcel",
          { responseType: "blob" },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `usuarios_que_han_referido_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar Excel:", error);
        this.$toast.error("Error al descargar el Excel", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadUsuariosSoloReferidosNoExitosos() {
      try {
        this.$toast.info(
          "Generando Excel de usuarios con solo referidos no exitosos...",
          {
            position: "top-right",
            timeout: 2000,
          },
        );

        const response = await this.$https.get(
          "/adminReports/downloadUsuariosSoloReferidosNoExitososExcel",
          { responseType: "blob" },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `usuarios_solo_referidos_no_exitosos_${new Date().toISOString().split("T")[0]}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success("Excel descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar Excel:", error);
        this.$toast.error("Error al descargar el Excel", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadConciliacionRetirosVentas() {
      try {
        this.$toast.info(
          "Generando reporte de conciliación Retiros - Ventas...",
          {
            position: "top-right",
            timeout: 2000,
          },
        );

        const response = await this.$https.get(
          "/adminReports/downloadReporteConciliacionRetirosVentasExcel",
          {
            responseType: "blob",
          },
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        const name = `conciliacion_retiros_ventas_${now.toISOString().slice(0, 10)}_${now.getHours()}${now.getMinutes()}.xlsx`;
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$toast.success(
          "Reporte de conciliación descargado correctamente",
          {
            position: "top-right",
            timeout: 3000,
          },
        );
      } catch (error) {
        console.error("Error al descargar reporte de conciliación:", error);
        this.$toast.error("Error al descargar el reporte de conciliación", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    /** Mes calendario en hora local del navegador (alineado con cómo se elegía antes el período). */
    calendarioMesActual() {
      const now = new Date();
      return {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
      };
    },
    calendarioMesAnterior() {
      const { year, month } = this.calendarioMesActual();
      if (month <= 1) return { year: year - 1, month: 12 };
      return { year, month: month - 1 };
    },
    async downloadVentasPorPeriodoMesActual() {
      const p = this.calendarioMesActual();
      await this.downloadVentasPorPeriodo(p.year, p.month);
    },
    async downloadVentasPorPeriodoMesAnterior() {
      const p = this.calendarioMesAnterior();
      await this.downloadVentasPorPeriodo(p.year, p.month);
    },
    async downloadVentasPorPeriodo(year, month) {
      try {
        this.$toast.info(
          `Generando ventas por período ${year}-${String(month).padStart(2, "0")}...`,
          {
            position: "top-right",
            timeout: 2000,
          },
        );
        const params = { year, month };
        const response = await this.$https.get(
          "/adminReports/downloadReporteVentasPorPeriodoExcel",
          { params, responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ventas_periodo_${params.year}-${String(params.month).padStart(2, "0")}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$toast.success("Reporte descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar ventas por período:", error);
        this.$toast.error("Error al descargar el reporte", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadVentasCerradasMesActual() {
      const p = this.calendarioMesActual();
      await this.downloadVentasCerradasPorPeriodo(p.year, p.month);
    },
    async downloadVentasCerradasMesAnterior() {
      const p = this.calendarioMesAnterior();
      await this.downloadVentasCerradasPorPeriodo(p.year, p.month);
    },
    async downloadVentasCerradasPorPeriodo(year, month) {
      try {
        this.$toast.info(
          `Generando reporte de ventas cerradas ${year}-${String(month).padStart(
            2,
            "0",
          )}...`,
          {
            position: "top-right",
            timeout: 2000,
          },
        );
        const params = { year, month };
        const response = await this.$https.get(
          "/adminReports/downloadReporteVentasCerradasExcel",
          { params, responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ventas_cerradas_${params.year}-${String(params.month).padStart(
            2,
            "0",
          )}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$toast.success("Reporte descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar ventas cerradas por período:", error);
        this.$toast.error("Error al descargar el reporte", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadVentasCerradas() {
      try {
        this.$toast.info("Generando reporte de ventas cerradas...", {
          position: "top-right",
          timeout: 2000,
        });
        const response = await this.$https.get(
          "/adminReports/downloadReporteVentasCerradasExcel",
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `ventas_cerradas_${new Date().toISOString().slice(0, 10)}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$toast.success("Reporte descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar ventas cerradas:", error);
        this.$toast.error("Error al descargar el reporte", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
    async downloadPendientePorRetirar() {
      try {
        this.$toast.info("Generando reporte de pendiente por retirar...", {
          position: "top-right",
          timeout: 2000,
        });
        const response = await this.$https.get(
          "/adminReports/downloadReportePendientePorRetirarExcel",
          { responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `pendiente_por_retirar_${new Date().toISOString().slice(0, 10)}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        this.$toast.success("Reporte descargado correctamente", {
          position: "top-right",
          timeout: 3000,
        });
      } catch (error) {
        console.error("Error al descargar pendiente por retirar:", error);
        this.$toast.error("Error al descargar el reporte", {
          position: "top-right",
          timeout: 5000,
        });
      }
    },
  },
};
</script>

<style scoped>
.reportes-container {
  padding: 0;
}

.stat-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.stat-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.stat-icon {
  font-size: 2rem;
  margin-right: 1rem;
  width: 60px;
  text-align: center;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  color: #2d3748;
}

.stat-label {
  font-size: 0.875rem;
  color: #718096;
  margin: 0.25rem 0 0 0;
}

.clickable-card {
  cursor: pointer;
}

.clickable-card:hover {
  background: #e9ecef !important;
  border-color: #007bff !important;
}
</style>
